<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-md-3 col-lg-4">
        <div class="text-head font-weight-bold text-black h2">Add an Asset</div>
        <BackRoute />
        <!-- <div class="border col-1 rounded p-1 cursor-pointer" @click="goBack">
          <el-icon :size="20" class="d-flex"><ArrowLeft /></el-icon>
        </div> -->
      </div>
    </div>
    <el-container>
      <el-row :gutter="15" class="w-100 m-0">
        <el-col class="d-block d-md-none">
          <div class="grey-bg" v-if="assetForm.barCode">
            <div class="bg-photo border-radius-8 py-4">
              <div class="person-img">
                <div v-if="barcodeLoading">
                  <el-icon class="is-loading"><Loading /></el-icon>
                </div>

                <img
                  v-if="assetForm.barCode"
                  :src="assetForm.barCode"
                  alt="Uploaded Image"
                />
              </div>
            </div>
          </div>
        </el-col>
        <el-col :sm="16" :md="16" :lg="16" :xl="16" class="p-0">
          <el-form :model="assetForm" ref="ruleForm" style="width: 100%">
            <div class="row mt-3">
              <div class="col-md-6 col-lg-5"></div>
              <div
                class="col-md-6 col-lg-7 d-flex justify-content-center w-100 s-24 fw-400 text-black"
              >
                Core Asset Information
              </div>
            </div>

            <el-form-item>
              <div
                class="d-flex mt-2 flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                >
                  Asset Name
                </label>
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.name"
                  placeholder="Asset name"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Category</label
                >
                <el-select-v2
                  v-model="categoriesId"
                  @change="setSelectedCategory"
                  :options="
                    categories.map((i) => ({ label: i.name, value: i.id }))
                  "
                  placeholder="Select Category"
                  size="large"
                  class="input-width"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Asset Code</label
                >
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.assetCode"
                  placeholder="code"
                  @blur="generateBarcode"
                />
                <span v-if="barcodeLoading">
                  <el-icon class="is-loading"><Loading /></el-icon
                ></span>
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Manufacturer</label
                >
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.manufacturer"
                  placeholder="manufacturer"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Model/Version</label
                >
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.modelVersion"
                  placeholder="model"
                />
              </div>
            </el-form-item>
            <div class="row mt-5">
              <div class="col-md-6 col-lg-5"></div>
              <div
                class="col-md-6 col-lg-7 d-flex justify-content-end w-100 s-24 fw-400 text-black"
              >
                Acquisition and Financial Details
              </div>
            </div>
            <el-form-item>
              <div
                class="d-flex mt-2 flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="purchaseDate"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                >
                  Purchase Date
                </label>
                <el-date-picker
                  v-model="assetForm.dateOfPurchase"
                  type="date"
                  format="MM/DD/YYYY"
                  size="large"
                  class="widthdate input-width"
                  placeholder="Select date"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Purchase Price</label
                >
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.amount"
                  placeholder="Purchase Price"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label for="" class="mr-3 s-18 fw-500 text-dak text-head"
                  >Warranty</label
                >
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.warranty"
                  placeholder="Warranty"
                />
              </div>
            </el-form-item>

            <div class="row mt-5">
              <div class="col-md-6 col-lg-5"></div>
              <div
                class="col-md-6 col-lg-7 d-flex justify-content-end w-100 s-24 fw-400 text-black"
              >
                Location, Status and Assignment
              </div>
            </div>

            <el-form-item>
              <div
                class="d-flex mt-2 flex-column flex-lg-row justify-content-end w-100"
              >
                <label for="" class="mr-3 s-18 fw-500 text-dak text-head">
                  Physical Location
                </label>
                <el-input
                  type="text"
                  class="input-width"
                  v-model="assetForm.location"
                  placeholder="Location"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Assigned Dept</label
                >
                <div class="input-width">
                  <el-tree-select
                    v-model="selectedTree"
                    class="w-100"
                    placeholder="Select group"
                    :data="groupMappedTree"
                    :render-after-expand="false"
                    :filter-node-method="filterNodeMethod"
                    @change="setGroupValue"
                    filterable
                    check-strictly
                  />
                </div>

                <!-- <el-select-v2
                  v-model="selectedDepartmentId"
                  @change="setSelectedDepartment"
                  :options="
                    departments.map((i) => ({ label: i.name, value: i.id }))
                  "
                  placeholder="Select"
                  size="large"
                  class="input-width"
                /> -->
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="firstName"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Assigned User</label
                >
                <div class="input-width">
                  <MembersSearch
                    @memberdetail="chooseContact"
                    :currentMember="selectedContact"
                  />
                </div>
                <!-- <el-select-v2
                  v-model="selectedUserId"
                  @change="setSelectedUser"
                  :options="users.map((i) => ({ label: i.name, value: i.id }))"
                  placeholder="Select"
                  size="large"
                  class="input-width"
                /> -->
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label for="" class="mr-3 s-18 fw-500 text-dak text-head"
                  >Status</label
                >
                <el-select-v2
                  v-model="selectedStatusId"
                  @change="setSelectedStatus"
                  :options="
                    statusOptions.map((i) => ({ label: i.name, value: i.id }))
                  "
                  placeholder="Select"
                  size="large"
                  class="input-width"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label for="" class="mr-3 s-18 fw-500 text-dak text-head"
                  >Condition</label
                >
                <el-select-v2
                  v-model="selectedConditionId"
                  @change="setSelectedCondition"
                  :options="
                    conditionOptions.map((i) => ({
                      label: i.name,
                      value: i.id,
                    }))
                  "
                  placeholder="Select"
                  size="large"
                  class="input-width"
                />
              </div>
            </el-form-item>
            <div class="row mt-5" v-if="true">
              <div class="col-md-6 col-lg-5"></div>
              <div
                class="col-md-6 col-lg-7 d-flex justify-content-end mb-2 w-100 s-24 fw-400 text-black"
              >
                Financial and Accounting
              </div>
            </div>
            <el-form-item v-if="true">
              <div class="justify-content-end d-flex col-md-12">
                <div class="d-flex flex-wrap justify-content-end mt-3">
                  <div>
                    <el-button
                      class="primary--text"
                      link
                      @click="showConnectDialog = true"
                    >
                      <el-icon><Link /></el-icon>
                      <span class="s-15 fw-500">Connect Accounts</span>
                    </el-button>
                  </div>
                  <div>
                    <el-button
                      @click="showPostLedgerDialog = true"
                      link
                      class="primary--text"
                    >
                      <el-icon><Document /></el-icon>
                      <span class="s-15 fw-500"> Post to Ledger</span>
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="true">
              <div class="justify-content-end d-flex flex-wrap col-md-12 px-0">
                <div class="col-md-6 col-11"></div>
                <div class="justify-content-end mt-3 px-0 col-md-6 col-11">
                  <div
                    v-if="savedAccountDetails"
                    class="mt-4 p-3 border rounded bg-light col-md-12"
                  >
                    <h5 class="fw-500 mb-2">Saved Information</h5>

                    <div class="d-flex justify-content-between">
                      <span>Account Type:</span>
                      <span>{{ savedAccountDetails.accountType }}</span>
                    </div>

                    <div class="d-flex justify-content-between">
                      <span>Account Name:</span>
                      <span>{{ savedAccountDetails.name }}</span>
                    </div>

                    <div class="d-flex justify-content-between">
                      <span>Depreciation %:</span>
                      <span>{{ savedAccountDetails.depreciationRate }}</span>
                    </div>

                    <div class="d-flex justify-content-between">
                      <span>Amount:</span>
                      <span>{{ savedAccountDetails.amount }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <!-- <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <label
                  for="depreciation"
                  class="mr-3 s-18 fw-500 text-dak text-head"
                  >Depreciation %</label
                >
                <el-input
                  type="phone"
                  class="input-width"
                  v-model="assetForm.depreciationRate"
                  placeholder="Depreciation"
                />
              </div>
            
            </el-form-item> -->

            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <div class="input-width mt-4">
                  <div class="fw-500 s-24 text-black">
                    Add images, Receipt etc
                  </div>

                  <div class="row">
                    <!-- Hidden input -->
                    <input
                      type="file"
                      ref="fileInput"
                      accept="image/*"
                      multiple
                      style="display: none"
                      @change="handleFiles"
                    />

                    <!-- Upload Button -->
                    <div class="col-md-12 mt-2" v-if="images.length < 3">
                      <el-button
                        round
                        link
                        color="#0745AF"
                        class="upload-area-btn w-100"
                        @click="triggerFileInput"
                      >
                        <span class="font-weight-600 s-14">Choose images</span>
                      </el-button>
                    </div>

                    <!-- Preview Images -->
                    <div
                      v-for="(img, index) in images"
                      :key="index"
                      class="col-md-4 mt-3 text-right"
                    >
                      <img
                        :src="img"
                        class="w-100 rounded"
                        style="height: 140px; object-fit: cover"
                      />
                      <el-button
                        link
                        size="small"
                        class="p-0 m-0"
                        @click="removeImage(index)"
                      >
                        <el-icon class="text-danger"><Close /></el-icon>
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item>
              <div
                class="d-flex flex-column flex-lg-row justify-content-end w-100"
              >
                <div class="input-width">
                  <div class="d-flex flex-column">
                    <el-button
                      class=""
                      size="large"
                      :color="primarycolor"
                      @click="saveAsset"
                      round
                    >
                      {{
                        navigatorLang === "en-US" ? "Save" : $t("people.save")
                      }}
                    </el-button>
                    <el-button
                      size="large"
                      link
                      class="secondary-butto mt-2 ml-0"
                      @click.prevent="onCancel"
                      round
                    >
                      {{
                        navigatorLang === "en-US"
                          ? "Cancel"
                          : $t("people.cancel")
                      }}
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="grey-bg d-none d-md-block">
            <div class="grey-bg">
              <div class="bg-photo bord">
                <div class="person-im mt-4">
                  <div v-if="barcodeLoading">
                    <el-icon class="is-loading"><Loading /></el-icon>
                  </div>

                  <img
                    v-if="assetForm.barCode"
                    :src="assetForm.barCode"
                    alt="Uploaded Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-container>

    <el-dialog
      v-model="showConnectDialog"
      title="Connect Accounts"
      :width="mdAndUp || lgAndUp || xlAndUp ? '50%' : '90%'"
      class="border-radius-8"
    >
      <div class="row justify-content-center mb-4">
        <!-- <div class="col-md-4 col"></div> -->
        <div class="col-md-8 col-12">
          <div class="d-flex flex-column flex-sm-row justify-content-center">
            <div class="mr-0 mr-md-3">
              <el-button
                class="w-100"
                :class="{
                  'primary-bg text-white': dialogMode === 'existing',
                  'secondary-button': dialogMode === 'new',
                  'secondary-button': !dialogMode,
                }"
                round
                @click="dialogMode = 'existing'"
              >
                Use Existing Account
              </el-button>
            </div>
            <div class="mt-3 mt-md-0">
              <el-button
                class="w-100"
                :class="{
                  'primary-bg text-white': dialogMode === 'new',
                  'secondary-button': dialogMode === 'existing',
                  'secondary-button': !dialogMode,
                }"
                round
                @click="dialogMode = 'new'"
              >
                Add New Account
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Use Existing Account -->
      <div
        class="row mt-5 justify-content-center"
        v-if="dialogMode === 'existing'"
      >
        <div class="col-md-10 col-12">
          <div class="row">
            <div class="col-md-4 text-md-right text-left">Select Account</div>
            <div class="col-md-8">
              <el-dropdown trigger="click" class="w-100 mt-2">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution w-100"
                    size="large"
                  >
                    <div>
                      {{
                        !selectedAccountType || !selectedAccountType.text
                          ? "Select account type"
                          : selectedAccountType.text
                      }}
                    </div>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(account, index) in transactionalAccounts"
                      :key="index"
                    >
                      <div class="col-md-12 px-2">
                        <div
                          v-if="index === 0"
                          class="py-2 font-weight-700 border-bottom"
                        >
                          {{ accountTypes[0] }}
                        </div>
                        <div
                          @click="selectAccountType(account, index)"
                          class="c-pointer py-2"
                        >
                          {{ account.text }}
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">
              Select Accumulated Depreciation
            </div>
            <div class="col-md-8">
              <el-select-v2
                v-model="depreciationAccountID"
                @change="setDepreciationAccount"
                :options="
                  depreciationAccounts.map((i) => ({
                    label: i.name,
                    value: i.id,
                  }))
                "
                placeholder="Select Depreciation"
                size="large"
                class="w-100"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Depreciation %</div>
            <div class="col-md-8">
              <el-input
                type="number"
                class="w-100"
                v-model="assetForm.depreciationRate"
                placeholder="Depreciation"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Amount</div>
            <div class="col-md-8">
              <el-input v-model="assetForm.amount" placeholder="Enter amount" />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4"></div>
            <div class="col-md-8 d-flex justify-content-center">
              <el-button
                round
                class="secondary-button"
                @click="showConnectDialog = false"
                >Cancel</el-button
              >
              <el-button
                class="text-white"
                round
                :color="primarycolor"
                @click="saveConnectedAccount"
                >Save</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Add New Account -->
      <div class="row mt-5 justify-content-center" v-if="dialogMode === 'new'">
        <div class="col-md-10 col-12">
          <div class="row">
            <div class="col-md-4 text-md-right text-left">
              Select Account Type
            </div>
            <div class="col-md-8">
              <el-dropdown trigger="click" class="w-100 mt-2">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution w-100"
                    size="large"
                  >
                    <div>
                      {{
                        !selectedNewAccountType || !selectedNewAccountType.name
                          ? "Select account type"
                          : selectedNewAccountType.name
                      }}
                    </div>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(account, index) in allFilteredAssetAcount"
                      :key="index"
                    >
                      <div class="col-md-12 px-2">
                        <div
                          v-if="index === 0"
                          class="py-2 font-weight-700 border-bottom"
                        >
                          {{ accountTypes[0] }}
                        </div>
                        <div
                          @click="selectNewAccountType(account, index)"
                          class="c-pointer py-2"
                        >
                          {{ account.name }}
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Account Name</div>
            <div class="col-md-8">
              <el-input
                v-model="assetForm.name"
                placeholder="Enter account name"
              />
            </div>
          </div>
          <!-- <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">
              Depreciation Account Type
            </div>
            <div class="col-md-8">
              <el-select-v2
                v-model="depreciationAccountID"
                @change="setDepreciationAccount"
                :options="
                  depreciationAccounts.map((i) => ({
                    label: i.name,
                    value: i.id,
                  }))
                "
                placeholder="Select Category"
                size="large"
                class="w-100"
              />
            </div>
          </div> -->
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">
              Depreciation Name
            </div>
            <div class="col-md-8">
              <div
                class="border-gray-400 border-radius-5"
                style="padding: 11px 11px !important"
              >
                acc. depre {{ assetForm.name }}
              </div>
              <!-- <el-input
                v-model="newAccount.depreciationName"
                placeholder="Enter depreciation name"
              /> -->
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Depreciation %</div>
            <div class="col-md-8">
              <el-input
                type="number"
                class="w-100"
                v-model="assetForm.depreciationRate"
                placeholder="Depreciation"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Amount</div>
            <div class="col-md-8">
              <el-input v-model="assetForm.amount" placeholder="Enter amount" />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4"></div>
            <div class="col-md-8 d-flex justify-content-center">
              <el-button
                round
                class="secondary-button"
                @click="showConnectDialog = false"
                >Cancel</el-button
              >
              <el-button
                class="text-white"
                round
                :color="primarycolor"
                @click="saveConnectedAccount"
                >Save</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- Connect Accounts Dialog -->
    <el-dialog
      v-model="showPostLedgerDialog"
      title="Post to Ledger"
      :width="mdAndUp || lgAndUp || xlAndUp ? '50%' : '90%'"
      class="border-radius-8"
    >
      <div class="row mt-5 justify-content-center">
        <div class="col-md-10 col-12">
          <div class="row">
            <div class="col-md-4 text-md-right text-left">Select Account</div>
            <div class="col-md-8">
              <el-dropdown trigger="click" class="w-100 mt-2">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution w-100"
                    size="large"
                  >
                    <div>
                      {{
                        !selectedCashAccountType ||
                        !selectedCashAccountType.text
                          ? "Select"
                          : selectedCashAccountType.text
                      }}
                    </div>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(account, index) in cashandbank"
                      :key="index"
                    >
                      <div class="col-md-12 px-2">
                        <div
                          v-if="index === 0"
                          class="py-2 font-weight-700 border-bottom"
                        >
                          {{ accountTypes[0] }}
                        </div>
                        <div
                          @click="selectCashAccountType(account, index)"
                          class="c-pointer py-2"
                        >
                          {{ account.text }}
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Account name</div>
            <div class="col-md-8">
              <el-input
                type="phone"
                class="w-100"
                v-model="assetForm.name"
                placeholder="name"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Depreciation %</div>
            <div class="col-md-8">
              <el-input
                type="number"
                class="w-100"
                v-model="assetForm.depreciationRate"
                placeholder="Depreciation"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 text-md-right text-left">Amount</div>
            <div class="col-md-8">
              <el-input v-model="assetForm.amount" placeholder="Enter amount" />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4"></div>
            <div class="col-md-8 d-flex justify-content-center">
              <el-button
                round
                class="secondary-button"
                @click="showPostLedgerDialog = false"
                >Cancel</el-button
              >
              <el-button
                class="text-white"
                round
                :color="primarycolor"
                @click="postToLedger"
                >Save</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import axios from "@/gateway/backendapi";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import router from "../../../router";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import assetService from "../../../services/asset/assetServices";
import grousService from "../../../services/groups/groupsservice";
import MembersSearch from "../../../components/membership/MembersSearch.vue";
import flatten from "../../../services/groupArray/flatTree";
import collector from "../../../services/groupArray/mapTree";
import { ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import transaction_service from "../../../services/financials/transaction_service";
import transactionals from "../../accounting/chartOfAccount/utilities/transactionals";
import chart_of_accounts from "../../../services/financials/chart_of_accounts";
import media_service from "../../../services/media/media_service"; // adjust to your path
// import transaction_service from "../../../../services/financials/transaction_service";

const primarycolor = inject("primarycolor");
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const route = useRoute();
const store = useStore();
const categoriesId = ref(null);
const selectedStatusId = ref(null);
const selectedConditionId = ref(null);
const depreciationAccountID = ref(null);
const savedAccountDetails = ref(null);
const navigatorLang = ref(navigator.language);
const selectedCategory = ref({});
const selectedUser = ref({});
const selectedStatus = ref({});
const selectedCondition = ref({});
const selectedDepartment = ref({});
const image = ref("");
const imageUrl = ref("");
const binImage = ref("");
const allGroups = ref([]);
const selectedTree = ref();
const groupMappedTree = ref([]);
const flattenedTree = ref([]);
const transactionalAccounts = ref([]);
const depreciationAccounts = ref([]);
const accountTypes = ref(transactionals.accountTypes);
const groupToAddTo = ref({});
const selectedAccountType = ref({});
const selectedNewAccountType = ref({});
const depreciationAccountType = ref({});
const selectedCashAccountType = ref({});

const showConnectDialog = ref(false);
const showPostLedgerDialog = ref(false);
const barcodeLoading = ref(false);
const allFilteredAssetAcount = ref([]);
const cashandbank = ref([]);
const dialogMode = ref(""); // or 'new'
const fileInput = ref(null);
const images = ref([]); // holds preview URLs
const loadingFile = ref(false);
const assetForm = ref({
  name: "",
  category: "",
  id: "",
  assetCode: "",
  manufacturer: "",
  modelVersion: "",
  dateOfPurchase: "",
  amount: "",
  warranty: "",
  depreciationRate: null,
  location: "",
  department: "",
  assignedUser: "",
  status: "",
  condition: "",
  barCode: "",
});

// Trigger hidden input
const triggerFileInput = () => {
  fileInput.value.click();
};
const generateBarcode = async () => {
  if (!assetForm.value.assetCode) {
    assetForm.value.barCode = null;
    return;
  }

  try {
    barcodeLoading.value = true;

    const res = await axios.get("/api/Asset/barcode", {
      params: { code: assetForm.value.assetCode },
    });

    assetForm.value.barCode = res.data; // base64 or URL returned
    barcodeLoading.value = false;
  } catch (err) {
    console.error("Error generating barcode:", err);
  } finally {
    barcodeLoading.value = false;
  }
};

const handleFiles = async (e) => {
  const files = e.target.files;
  if (!files) return;

  for (let i = 0; i < files.length && images.value.length < 3; i++) {
    let formData = new FormData();
    formData.append("mediaFileImage", files[i]);

    try {
      loadingFile.value = true;
      const res = await media_service.uploadFileAndImage(formData);

      // assuming API returns the uploaded file URL
      if (res?.pictureUrl) {
        images.value.push(res.pictureUrl);
      } else {
        ElNotification({
          type: "error",
          message: "Upload succeeded but no URL returned:",
          duration: 5000,
        });
      }
    } catch (err) {
      console.log(err);
      ElNotification({
        type: "error",
        message: "Upload failed:",
        duration: 5000,
      });
    } finally {
      loadingFile.value = false;
    }
  }

  fileInput.value.value = ""; // reset input
};

// Remove selected image
const removeImage = (index) => {
  images.value.splice(index, 1);
};

const getCashAndBank = async () => {
  try {
    const response = await transaction_service.getCashAndBank();
    cashandbank.value = response;
    // selectedCashAccount.value =
    //   cashandbank.value && cashandbank.value[0] ? cashandbank.value[0] : {};
  } catch (error) {
    console.log(error);
  }
};
getCashAndBank();
const getTransactionalAccounts = async () => {
  try {
    const response = await transactionals.getGroupedAccounts();

    if (Array.isArray(response) && Array.isArray(response[3])) {
      transactionalAccounts.value = response[0]; // Assets
      console.log("Filtered Asset accounts:", transactionalAccounts.value);
    } else {
      console.warn(
        "Unexpected response format or missing Asset group:",
        response
      );
    }
  } catch (error) {
    console.error("Error fetching transactional accounts:", error);
  }
};

getTransactionalAccounts();
const getAllDepreciationAccounts = async () => {
  try {
    const response = await chart_of_accounts.getChartOfAccounts();

    if (response && Array.isArray(response.accountwithHeads)) {
      const assetsGroup = response.accountwithHeads.find(
        (item) => item.key === "Assets"
      );

      if (!assetsGroup || !Array.isArray(assetsGroup.accountHeadsDTO)) {
        console.warn("Assets group or accountHeadsDTO not found.");
        return;
      }

      const depreciationHead = assetsGroup.accountHeadsDTO.find(
        (head) => head.name === "Accumulated Depreciation"
      );

      if (!depreciationHead || !Array.isArray(depreciationHead.accounts)) {
        console.warn("Accumulated Depreciation not found or has no accounts.");
        return;
      }

      // ✅ Final depreciation accounts under Assets
      depreciationAccounts.value = depreciationHead.accounts;
      console.log(
        "Depreciation Accounts under Assets:",
        depreciationAccounts.value
      );
    } else {
      console.warn("Unexpected response format:", response);
    }
  } catch (error) {
    console.error("Error fetching depreciation accounts:", error);
  }
};

getAllDepreciationAccounts();
const getFilteredAssetsHeads = async () => {
  try {
    const response = await chart_of_accounts.getChartOfAccounts();

    if (!response || !Array.isArray(response.accountwithHeads)) {
      console.warn("Invalid chart of accounts data.");
      return [];
    }

    // 1️⃣ Find Assets group
    const assetsGroup = response.accountwithHeads.find(
      (group) => group.key?.toLowerCase() === "assets"
    );

    if (!assetsGroup?.accountHeadsDTO) {
      console.warn("Assets group not found or invalid.");
      return [];
    }

    // 2️⃣ Filter out unwanted heads
    const filteredHeads = assetsGroup.accountHeadsDTO.filter(
      (head) =>
        head.name?.toLowerCase() !== "cash and bank" &&
        head.name?.toLowerCase() !== "accumulated depreciation"
    );

    allFilteredAssetAcount.value = filteredHeads;
    console.log("Filtered Asset Heads:", allFilteredAssetAcount.value);
    // return filteredHeads;
  } catch (err) {
    console.log(err);
    // ElNotification({
    //   type: "error",
    //   message: "Error fetching filtered asset heads",
    //   duration: 5000,
    // });
    return [];
  }
};
getFilteredAssetsHeads();
const selectAccountType = (account, index) => {
  selectedAccountType.value = account;
  console.log(account, "assets");
};
const selectNewAccountType = (account, index) => {
  selectedNewAccountType.value = account;
  console.log(selectedNewAccountType.value, "assets");
};
const selectCashAccountType = (account, index) => {
  selectedCashAccountType.value = account;
  console.log(selectedCashAccountType.value, "selectedCashAccountType");
};
const setDepreciationAccount = () => {
  depreciationAccountType.value = depreciationAccounts.value.find((i) => {
    return i.id == depreciationAccountID.value;
  });
  console.log("Selected Depreciation Account:", depreciationAccountType.value);
};
const existingAccount = ref({
  accountType: "",
  depreciationType: "",
  amount: "",
});

const newAccount = ref({
  accountType: "",
  accountName: "",
  depreciationType: "",
  depreciationName: "accu. depre",
});

// const saveConnectedAccount = () => {
//   newAccount.value = {};
//   existingAccount.value = {};

//   ElNotification.success("Account connected successfully");

// };
const saveConnectedAccount = () => {
  savedAccountDetails.value = {
    type: dialogMode.value,
    name:
      dialogMode.value === "existing"
        ? assetForm.value.name
        : depreciationAccountType.value?.name,
    amount: assetForm.value.amount,
    depreciationRate: assetForm.value.depreciationRate,
    accountType:
      dialogMode.value === "existing"
        ? selectedAccountType.value.text
        : selectedNewAccountType.value.name,
  };

  newAccount.value = {};
  existingAccount.value = {};

  ElNotification.success("Account connected successfully");
  // ✅ Keep dialog open so user sees the details
  showConnectDialog.value = false;
};
const postToLedger = () => {
  showPostLedgerDialog.value = false;
  savedAccountDetails.value = {
    type: "postToLedger",
    name: assetForm.value.name,
    amount: assetForm.value.amount,
    depreciationRate: assetForm.value.depreciationRate,
    accountType: selectedCashAccountType.value.text,
  };

  ElNotification({
    type: "success",
    message: "Account Posted to Ledger Successfully",
    duration: 5000,
  });
};

const categories = ref([]);

const statusOptions = ref([
  {
    name: "Available",
    id: 0,
  },
  { name: "InUse", id: 1 },
  { name: "UnderMaintenance", id: 2 },
  { name: "Retired", id: 3 },
]);

const conditionOptions = ref([
  {
    name: "New",
    id: 0,
  },
  { name: "Used", id: 1 },
  { name: "Refurbished", id: 2 },
  { name: "Damaged", id: 3 },
]);

const chooseContact = (payload) => {
  // payload.firstName = payload.name;
  selectedUser.value = payload;
};

const setSelectedCategory = () => {
  selectedCategory.value = categories.value.find((i) => {
    return i.id == categoriesId.value;
  });
};
// const setSelectedDepartment = () => {
//   selectedDepartment.value = departments.value.find((i) => {
//     return i.id == selectedDepartmentId.value;
//   });
// };
// const setSelectedUser = () => {
//   selectedUser.value = users.value.find((i) => {
//     return i.id == selectedUserId.value;
//   });
// };
const setSelectedStatus = () => {
  selectedStatus.value = statusOptions.value.find((i) => {
    return i.id == selectedStatusId.value;
  });
};
const setSelectedCondition = () => {
  selectedCondition.value = conditionOptions.value.find((i) => {
    return i.id == selectedConditionId.value;
  });
};
const getAssetById = async () => {
  if (route.query.id) {
    try {
      const response = await assetService.getAssetById(route.query.id);
      console.log(response, "single assest");
      assetForm.value = response;
      images.value = [];
      if (response.defaultImageUrl) images.value.push(response.defaultImageUrl);
      if (response.image2Url) images.value.push(response.image2Url);
      if (response.image3Url) images.value.push(response.image3Url);
    } catch (error) {}
  }
};
getAssetById();
const getCategory = async () => {
  try {
    const response = await assetService.getCategories();
    categories.value = response || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    // ElNotification({
    //   type: "error",
    //   message: "Failed to load categories",
    //   duration: 5000,
    // });
  }
};
getCategory();
const getGroups = async () => {
  try {
    let groups = store.getters["groups/groups"];
    if (groups && groups.length > 0) {
      allGroups.value = groups;
    } else {
      let group = await grousService.getGroups();
      if (group.response && group.response.groupResonseDTO) {
        allGroups.value = group.response.groupResonseDTO;
      }
    }
    let data = { children: allGroups.value };
    const { children } = collector(data);
    groupMappedTree.value = children;
    if (groupMappedTree.value && groupMappedTree.value.length > 0) {
      flattenedTree.value = groupMappedTree.value.flatMap(flatten());
    }
  } catch (error) {
    console.log(error);
  }
};

getGroups();
const setGroupValue = () => {
  const response = flattenedTree.value.find(
    (i) => i.value == selectedTree.value
  );
  groupToAddTo.value = {
    name: response.label,
    id: response.value,
  };
};

const filterNodeMethod = (value, data) =>
  data.label.toLowerCase().includes(value.toLowerCase());
const saveAsset = async () => {
  // ✅ Basic validation
  if (!assetForm.value.name || assetForm.value.name.trim() === "") {
    ElNotification({
      type: "warning",
      message: "Asset Name is required",
      duration: 4000,
    });
    return;
  }

  if (!selectedCategory.value?.id && !categoriesId.value) {
    ElNotification({
      type: "warning",
      message: "Please select a category",
      duration: 4000,
    });
    return;
  }
  try {
    const payload = {
      name: assetForm.value.name,
      assetCategoryId: selectedCategory.value?.id || null,
      assetCode: assetForm.value.assetCode,
      manufacturer: assetForm.value.manufacturer,
      modelVersion: assetForm.value.modelVersion,
      dateOfPurchase: assetForm.value.dateOfPurchase,
      amount: assetForm.value.amount || 0,
      warranty: assetForm.value.warranty,
      depreciationRate: parseInt(assetForm.value.depreciationRate) || 0,
      location: assetForm.value.location,
      groupID: selectedDepartment.value?.id || null,
      personID: selectedUser.value?.id || null,
      status: selectedStatus.value?.id || 0,
      financialAssetAccountID:
        selectedAccountType.value?.id ||
        selectedNewAccountType.value?.id ||
        selectedCashAccountType.value?.id ||
        "",
      financialDepreciationAccountID: depreciationAccountType.value?.id || "",
      condition: selectedCondition.value?.id || 0,
      defaultImageUrl: images.value[0] || "",
      image2Url: images.value[1] || "",
      image3Url: images.value[2] || "",
    };

    // Call API with FormData
    if (route.query.id) {
      payload.id = route.query.id;
      const response = await assetService.updateAsset(route.query.id, payload);
      ElNotification({
        type: "success",
        message: "Asset updated successfully",
        duration: 5000,
      });
    } else {
      const response = await assetService.createAsset(payload);
      // const response = await assetService.createAsset(formData);
      console.log("Asset created:", response);
      ElNotification({
        type: "success",
        message: "Asset created successfully",
        duration: 5000,
      });
    }

    router.push("/tenant/asset");
  } catch (err) {
    console.error("Error creating asset:", err);
    ElNotification({
      type: "error",
      message: "Failed to create asset",
      duration: 5000,
    });
  }
};

const cancel = () => {
  // Handle cancel action
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.input-width {
  width: 100%;
}

::v-deep(.widthdate) {
  width: 22rem !important;
}

.widthdate {
  width: 100%;
}

@media (max-width: 682px) {
  ::v-deep(.widthdate) {
    width: 100% !important;
  }

  .widthdate {
    width: 100%;
  }
}
@media (min-width: 992px) {
  .input-width {
    width: 350px;
  }
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 650px;
    margin: 1.75rem auto;
    /* padding: 32px; */
  }

  .dropdown-menu {
    max-height: 300px;
    overflow: scroll;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
      0 1px 10px 0 rgb(0 0 0 / 12%);
  }
}

.div-card {
  position: absolute;
  background: white;
  z-index: 1;
  width: 100%;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  max-height: 400px;
  overflow: scroll;
}

.menu-height {
  max-height: 400px;
  overflow: scroll;
}

.tb-icon-span {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dde2e6;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  opacity: 0.5;
}
.border-line {
  border-radius: 30px;
  border: 1px dashed #0745af;
}
.upload-area-btn {
  border: 2px dashed #0745af !important;
  color: #0745af !important;
}
</style>
